import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Unrent from './Unrent';
import Prep from './Prep';
import Def_Sp from './Def_Sp';
import Unocc from './Unocc';
import Delay from './Delay';
import Rent_Signal from './Rent_Signal';

export default class Control_Param extends Component {
	constructor(props) {
		super(props);

		let ctrl_param = {};
		if (!isEmpty(this.props.param.ctrl_param)) {
			ctrl_param = JSON.parse(JSON.stringify(this.props.param.ctrl_param))
		} else {
			ctrl_param = {
				"unrent": {
					"stat": "off",
					"sp": [
						null,
						null
					],
					"fan": "L",
					"rcp": false
				},
				"prep": {
					"stat": "off",
					"sp": [
						null,
						null
					],
					"fan": "L"
				},
				"def_sp": [
					null,
					null
				],
				"unocc": {
					"stat": "off",
					"sp": [
						null,
						null
					],
					"fan": "L",
					"rcp": false
				},
				"win_delay": -1,
				"unocc_delay": -1,
				"rem_rent_op": false
			}
		}

		this.state = {
			ctrl_param: ctrl_param,
		}
	}

	handlePrevious = () => {
		let param = this.props.param;
		delete param.ctrl_param;
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Guest_Room_Settings', param);
	}

	handleChangeStat = (type, val) => {
		let ctrl_param = this.state.ctrl_param;
		ctrl_param[type].stat = val;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeCSP = (type, val) => {
		if (val != null) val = parseFloat(val);
		let ctrl_param = this.state.ctrl_param;
		ctrl_param[type].sp[0] = val;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeHSP = (type, val) => {
		if (val != null) val = parseFloat(val);
		let ctrl_param = this.state.ctrl_param;
		ctrl_param[type].sp[1] = val;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeDefSpCSP = (val) => {
		if (val != null) val = parseFloat(val);
		let ctrl_param = this.state.ctrl_param;
		ctrl_param.def_sp[0] = val;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeDefSpHSP = (val) => {
		if (val != null) val = parseFloat(val);
		let ctrl_param = this.state.ctrl_param;
		ctrl_param.def_sp[1] = val;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeFanstep = (type, val) => {
		let ctrl_param = this.state.ctrl_param;
		ctrl_param[type].fanstep = val;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeRCP = (type, val) => {
		let ctrl_param = this.state.ctrl_param;
		ctrl_param[type].rcp = !ctrl_param[type].rcp;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeDelay = (type, val) => {
		if (val != null) val = parseInt(val);
		let ctrl_param = this.state.ctrl_param;
		ctrl_param[type] = val;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleChangeRemRentOp = (val) => {
		let ctrl_param = this.state.ctrl_param;
		ctrl_param.rem_rent_op = !ctrl_param.rem_rent_op;

		this.setState({ ctrl_param: ctrl_param });
	}

	handleRegister = () => {
		this.props.receiver.setControlParam(this.state.ctrl_param);
	}

	rcvSetControlParam = (response) => {
		if (response.result != 'OK') {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		} else {
			this.handlePrevious();
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let container_style = {
			width: this.props.width - 60,
			backgroundColor: 'white',
			marginTop: 10,
			marginBottom: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			padding: 10,
		}

		let container_item_style = {
			marginLeft: 10,
			marginBottom: 10,
			textAlign: 'left'
		}

		const stat_range = [];
		stat_range.push(<option value={'on'}>{this.props.receiver.getString('on')}</option>);
		stat_range.push(<option value={'off'}>{this.props.receiver.getString('off')}</option>);
		stat_range.push(<option value={'setback'}>{this.props.receiver.getString('setback')}</option>);

		const prep_stat_range = [];
		prep_stat_range.push(<option value={'on'}>{this.props.receiver.getString('on')}</option>);
		prep_stat_range.push(<option value={'off'}>{this.props.receiver.getString('off')}</option>);

		const csp_range = [];
		csp_range.push(<option value={null}>{'--'}</option>);
		for (let i = 16; i <= 32; i += 0.5) {
			csp_range.push(<option value={i}>{i + this.props.receiver.getString('DEG')}</option>);
		}

		const hsp_range = [];
		hsp_range.push(<option value={null}>{'--'}</option>);
		for (let i = 16; i <= 32; i += 0.5) {
			hsp_range.push(<option value={i}>{i + this.props.receiver.getString('DEG')}</option>);
		}

		const fanstep_range = [];
		fanstep_range.push(<option value={'L'}>{this.props.receiver.getString('low')}</option>);
		fanstep_range.push(<option value={'M'}>{this.props.receiver.getString('medium')}</option>);
		fanstep_range.push(<option value={'H'}>{this.props.receiver.getString('high')}</option>);

		const win_delay_range = [];
		win_delay_range.push(<option value={-1}>{this.props.receiver.getString('ignore')}</option>);
		win_delay_range.push(<option value={0}>{this.props.receiver.getString('no_delay')}</option>);
		for (let i = 1; i <= 5; i++) {
			win_delay_range.push(<option value={i}>{i}</option>);
		}

		const unocc_delay_range = [];
		unocc_delay_range.push(<option value={0}>{this.props.receiver.getString('no_delay')}</option>);
		for (let i = 1; i <= 10; i++) {
			unocc_delay_range.push(<option value={i}>{i}</option>);
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('set_ctrl_param')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 20, height: this.props.height - 120, overflow: 'auto' }}>
						<Unrent
							container_style={container_style}
							container_item_style={container_item_style}
							receiver={this.props.receiver}
							width={this.props.width}
							stat_range={stat_range}
							csp_range={csp_range}
							hsp_range={hsp_range}
							fanstep_range={fanstep_range}
							ctrl_param={this.state.ctrl_param}
							handleChangeStat={(val) => { this.handleChangeStat('unrent', val) }}
							handleChangeCSP={(val) => { this.handleChangeCSP('unrent', val) }}
							handleChangeHSP={(val) => { this.handleChangeHSP('unrent', val) }}
							handleChangeFanstep={(val) => { this.handleChangeFanstep('unrent', val) }}
							handleChangeRCP={(val) => { this.handleChangeRCP('unrent', val) }}
						/>
						<Prep
							container_style={container_style}
							container_item_style={container_item_style}
							receiver={this.props.receiver}
							width={this.props.width}
							prep_stat_range={prep_stat_range}
							csp_range={csp_range}
							hsp_range={hsp_range}
							fanstep_range={fanstep_range}
							ctrl_param={this.state.ctrl_param}
							handleChangeStat={(val) => { this.handleChangeStat('prep', val) }}
							handleChangeCSP={(val) => { this.handleChangeCSP('prep', val) }}
							handleChangeHSP={(val) => { this.handleChangeHSP('prep', val) }}
							handleChangeFanstep={(val) => { this.handleChangeFanstep('prep', val) }}
						/>
						<Def_Sp
							container_style={container_style}
							container_item_style={container_item_style}
							receiver={this.props.receiver}
							width={this.props.width}
							ctrl_param={this.state.ctrl_param}
							csp_range={csp_range}
							hsp_range={hsp_range}
							handleChangeDefSpCSP={this.handleChangeDefSpCSP}
							handleChangeDefSpHSP={this.handleChangeDefSpHSP}
						/>
						<Unocc
							container_style={container_style}
							container_item_style={container_item_style}
							receiver={this.props.receiver}
							width={this.props.width}
							stat_range={stat_range}
							csp_range={csp_range}
							hsp_range={hsp_range}
							fanstep_range={fanstep_range}
							ctrl_param={this.state.ctrl_param}
							handleChangeStat={(val) => { this.handleChangeStat('unocc', val) }}
							handleChangeCSP={(val) => { this.handleChangeCSP('unocc', val) }}
							handleChangeHSP={(val) => { this.handleChangeHSP('unocc', val) }}
							handleChangeFanstep={(val) => { this.handleChangeFanstep('unocc', val) }}
							handleChangeRCP={(val) => { this.handleChangeRCP('unocc', val) }}
						/>
						<Delay
							container_style={container_style}
							container_item_style={container_item_style}
							receiver={this.props.receiver}
							width={this.props.width}
							ctrl_param={this.state.ctrl_param}
							win_delay_range={win_delay_range}
							unocc_delay_range={unocc_delay_range}
							handleChangeWinDelay={(val) => { this.handleChangeDelay('win_delay', val) }}
							handleChangeUnoccDelay={(val) => { this.handleChangeDelay('unocc_delay', val) }}
						/>
						<Rent_Signal
							container_style={container_style}
							container_item_style={container_item_style}
							receiver={this.props.receiver}
							width={this.props.width}
							ctrl_param={this.state.ctrl_param}
							handleChangeRemRentOp={this.handleChangeRemRentOp}
						/>
					</div>
				</div>
			</div>
		)
	}
}